import actions from "@/store/modules/referee/actions";
import mutations from "@/store/modules/referee/mutations";

const state = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
